<!-- Emissao do Pré-contrato -->
<div class="timeline-badge">
  <a><em class="fa fa-circle"></em></a>
</div>

<h4 *ngIf="timelineActive">{{ timeline.dataHora | date:'HH:mm'}} <small>{{ timeline.dataHora | date:'dd/MM/yyyy'}}</small></h4>

<div class="timeline-panel" [ngClass]="{'timeline-panel-disabled': !timelineActive}">

  <div class="step">
    <span class="icon"></span>
    <h2>{{ timeline.tituloStatus }}</h2>
    <span>{{ timeline.subTituloStatus}}</span>

    <div *ngIf="timelineActive">
      <div class="required-documents-panel" *ngIf="getPreContractDocuments()">
        <div class="required-documents">
          <ul>
            <li class="required-documents-item" *ngFor="let doc of getPreContractDocuments(); index as i">
              {{ doc.descDocto }}
            </li>
          </ul>
        </div>
      </div>

      <button
        *ngIf="timeline.cardDireito.length > 0"
        class="btn btn-border-orange pre-contrato__action"
        (click)="onClickEmitPreContract()">
        Emitir Pré-Contrato
      </button>
    </div>

    <div *ngIf="!timelineActive"><br /></div>

  </div>

</div>

<app-loader-circles *ngIf="isLoading"></app-loader-circles>
